import { $, w } from './constants';

const STORAGE_KEY = 'bannerAntifraude';
const EXP_DAYS = 14;

function setClosed() {
    const expiresAt = Date.now() + (EXP_DAYS * 24 * 60 * 60 * 1000);
    localStorage.setItem(STORAGE_KEY, String(expiresAt));
}

function isClosed() {
    const storedValue = localStorage.getItem(STORAGE_KEY);
    const expiresAt = parseInt(storedValue, 10);

    if (!storedValue || Number.isNaN(expiresAt)) return false;

    if (Date.now() > expiresAt) {
        localStorage.removeItem(STORAGE_KEY);
        return false;
    }

    return true;
}

$(function () {
    const $popup = $('#home_antifraude');
    const $slider = $('.home-template__hero-slider');

    if (!$popup.length || !$slider.length) return;

    const $closeBtn = $('#home_antifraude_close');
    const $readMore = $popup.find('.show_antifraude');
    const $wrapper = $popup.find('.home-template__pop-up-wrapper');
    const $content = $popup.find('.home-template__pop-up-content .content');
    const $popupContainer = $popup.children('.container');
    const $ctas = $('.banner_antifraude_cta');

    const EXTRA_POP_SPACE_DESKTOP = 110;
    const EXTRA_POP_SPACE_MOBILE = 140;

    function isMobile() {
        return $(w).width() < 950;
    }

    function getPopupVisibleHeight() {
        if (isMobile()) {
            return Math.ceil($popupContainer.outerHeight() || 0);
        }

        return Math.ceil($popup.outerHeight() || 0);
    }

    function applyHeroOffset() {
        if ($popup.hasClass('hide') || !$popup.is(':visible')) {
            resetHeroOffset();
            return;
        }

        const extraSpace = isMobile() ? EXTRA_POP_SPACE_MOBILE : EXTRA_POP_SPACE_DESKTOP;
        const visibleHeight = getPopupVisibleHeight();
        const popHeight = visibleHeight + extraSpace;

        $slider.addClass('home-template__hero-slider--pop');
        $slider[0].style.setProperty('--height-pop', `${popHeight}px`);
    }

    function resetHeroOffset() {
        $slider.removeClass('home-template__hero-slider--pop');
        $slider[0].style.removeProperty('--height-pop');
        $slider[0].style.removeProperty('--height-inner');
    }

    function resetDesktopPopupStyles() {
        $popup.removeClass('is-expanded');
        $ctas.removeClass('is-expanded');
        $popup.css('height', '');
        $popupContainer.css('height', '');
        $wrapper.css('height', '');
        $content.css({
            'max-height': '',
            'opacity': ''
        });
    }

    function setClosedStateMobile() {
        if (!isMobile()) {
            resetDesktopPopupStyles();
            applyHeroOffset();
            return;
        }

        $popup.removeClass('is-expanded');
        $ctas.removeClass('is-expanded');

        $content.css({
            'max-height': '0px',
            'opacity': '0'
        });

        $readMore.show();

        $popupContainer.css('height', 'auto');
        $wrapper.css('height', 'auto');

        const closedHeight = Math.ceil($wrapper.outerHeight() || 0);

        $popup.attr('data-closed-height', closedHeight);
        $popupContainer.css('height', `${closedHeight}px`);
        $wrapper.css('height', `${closedHeight}px`);
    }

    function openPopupMobile() {
        if (!isMobile()) return;

        const contentHeight = Math.ceil($content[0].scrollHeight || 0);
        const closedHeight = parseFloat($popup.attr('data-closed-height')) || 0;

        $popup.addClass('is-expanded');
        $ctas.addClass('is-expanded');
        $popupContainer.css('height', `${closedHeight}px`);

        $wrapper.css('height', 'auto');

        $content.css({
            'max-height': `${contentHeight}px`,
            'opacity': '1'
        });

        $readMore.hide();
    }

    function recalcAll() {
        if ($popup.hasClass('hide')) {
            resetHeroOffset();
            return;
        }

        if (isMobile()) {
            if ($popup.hasClass('is-expanded')) {
                const contentHeight = Math.ceil($content[0].scrollHeight || 0);
                const closedHeight = parseFloat($popup.attr('data-closed-height')) || 0;

                $popupContainer.css('height', `${closedHeight}px`);
                $wrapper.css('height', 'auto');
                $content.css({
                    'max-height': `${contentHeight}px`,
                    'opacity': '1'
                });
                $readMore.hide();
            } else {
                setClosedStateMobile();
            }
        } else {
            resetDesktopPopupStyles();
        }

        applyHeroOffset();
    }

    if (isClosed()) {
        $popup.hide().addClass('hide');
        resetHeroOffset();
        $ctas.removeClass('active_banner is-expanded');
    } else {
        $popup.show().removeClass('hide');
        $ctas.addClass('active_banner');

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                recalcAll();
            });
        });
    }

    $closeBtn.on('click', function () {
        setClosed();
        $ctas.removeClass('active_banner is-expanded');

        $popup.fadeOut(200, function () {
            $popup.addClass('hide').removeClass('is-expanded');
            resetHeroOffset();

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    if ($slider.hasClass('slick-initialized')) {
                        $slider.slick('setPosition');
                    }

                    $(window).trigger('resize');
                });
            });
        });
    });

    $readMore.on('click', function () {
        openPopupMobile();

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                recalcAll();

                if ($slider.hasClass('slick-initialized')) {
                    $slider.slick('setPosition');
                }
            });
        });
    });

    $(w).on('resize', function () {
        recalcAll();
    });

    $(window).on('load', function () {
        recalcAll();
    });
});